import PostListView from './PostListView';

export default PostListView;
